var base = require('settings/profile/update-contact-information');

Vue.component('spark-update-contact-information', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/profile/update-contact-information.js